define('modules/htmlad/templates/collection/htmlad_templates_collection_item_view',[
  'backbone',
  'jquery',
  '_',

  'modules/util/collection/collection_view',
  'modules/button/button_view',

  'text!./htmlad_template_header_template.html',
  'text!./htmlad_template_grid_item_template.html',
  'text!./htmlad_template_list_item_template.html',

  'modules/htmlad/templates/favorites/favorite_model',
], function (
  Backbone,
  $,
  _,
  CollectionView,
  ButtonView,
  header_template,
  grid_template,
  list_template,
  FavoriteModel
) {
  'use strict';
  var View = Backbone.View.extend(
    {
      initialize: function (opts) {
        _.extend(this, opts);

        this.viewType = this.viewType ? this.viewType : CollectionView.LIST;

        this.render();
      },

      subViews: [],
      tagName: 'div',
      events: {
        'click .js-update-favorite': 'updateFavorite',
      },
      grid_template: _.template(grid_template),
      list_template: _.template(list_template),
      render: function () {
        var json = this.model.toJSON();
        $.extend(json, this.extraParams);
        var formats = this.formats(this.model.attributes.orientations);
        $.extend(json, { formats: formats });

        if (this.viewType === CollectionView.GRID) {
          this.$el.html(this.grid_template(json));
        } else {
          this.$el.html(this.list_template(json));
        }

        if (this.extraParams) {
          var id = this.model.id;
          var zone_id = this.extraParams.zone_id;
          var player_id = this.extraParams.player_id;
          var extraParams = player_id
            ? '&player_id=' + player_id
            : '&zone_id=' + zone_id;

          var button = new ButtonView({
            label: 'htmlad_template.button.choose',
            icon: 'select',
            className: 'button list-button-actions',
            href: '/ads/new?template_id=' + id + extraParams,
          });
          this.$('.js-htmlad-action-buttons').append(button.$el);
        }

        this.renderStoreIcons(this.model.get('profiles'));
        this.renderFormatIcons(formats);

        return this;
      },

      renderStoreIcons: function (profiles) {
        var icons = [];
        profiles.forEach(function (profile) {
          var profileChar = document.createTextNode(
            profile.charAt(0).toUpperCase()
          );
          var span = document.createElement('div');
          span.classList.add('store-icon');
          span.classList.add('store-icon-' + profile.charAt(0).toLowerCase());
          span.appendChild(profileChar);
          span.setAttribute('title', profile);
          icons.push(span);
        });
        this.$('.js-store-icons').append(icons);
      },

      renderFormatIcons: function (formats) {
        var icon_formats = ['16:9', '9:16', '17:5', '32:9'];
        var icons = [];
        icon_formats.forEach(function (format) {
          var span = document.createElement('span');
          span.classList.add('format-icon');
          if (_.contains(formats, format)) {
            span.classList.add('format-icon-active');
          }
          span.appendChild(document.createTextNode(format));
          icons.push(span);
        });
        this.$('.js-format-icons').append(icons);
      },

      formats: function (orientations) {
        var formats = [];
        orientations.forEach(function (orientation) {
          formats.push(orientation.orientation);
        });
        return formats;
      },

      updateFavorite: function (e) {
        e.preventDefault();

        var templateId = this.model.get('id');
        var isFavorite = this.model.get('favorite') == false ? true : false;

        if (isFavorite) {
          this.$('#favorite > span').addClass('icon-favorite');
          this.$('#favorite > span').removeClass('icon-favorite-white');
          this.$('#favorite > span')[0].setAttribute(
            'title',
            _.t('htmlad_template.tooltip.favorite')
          );
        } else {
          this.$('#favorite > span').addClass('icon-favorite-white');
          this.$('#favorite > span').removeClass('icon-favorite');
          this.$('#favorite > span')[0].setAttribute(
            'title',
            _.t('htmlad_template.tooltip.save_as_favorite')
          );
        }

        var favorite = new FavoriteModel({
          htmltemplate_id: templateId,
          is_favorite: isFavorite,
        });

        favorite.save(null, { type: 'PUT' });
        this.model.set('favorite', isFavorite);
      },

      remove: function () {
        _.each(this.subViews, function (view) {
          if (view && view.remove) {
            view.remove();
          }
        });
        this.$el.off();
        this.$el.remove();
        this.stopListening();
        return this;
      },
    },
    {
      header: function (collection) {
        return _.template(header_template)(collection.params);
      },
      viewTypes: [CollectionView.GRID],
    }
  );
  return View;
});

